(function () {
  'use strict';

  var backdrop = document.getElementById('qv-backdrop');
  var modal = document.getElementById('qv-modal');
  var closeBtn = document.getElementById('qv-close');
  var loading = document.getElementById('qv-loading');
  var content = document.getElementById('qv-content');
  var imgEl = document.getElementById('qv-image');
  var thumbsEl = document.getElementById('qv-thumbs');
  var typeEl = document.getElementById('qv-product-type');
  var titleEl = document.getElementById('qv-title');
  var priceEl = document.getElementById('qv-price');
  var compareEl = document.getElementById('qv-compare');
  var badgeEl = document.getElementById('qv-badge');
  var variantsEl = document.getElementById('qv-variants');
  var unavailableEl = document.getElementById('qv-unavailable');
  var atcBtn = document.getElementById('qv-atc');
  var pdpLink = document.getElementById('qv-pdp-link');

  if (!modal) return;

  var product = null;
  var selectedOptions = {};

  // --- helpers for Shopify option format (string or {name, values} object) ---
  function optName(opt) {
    return typeof opt === 'string' ? opt : opt.name;
  }
  function optValues(opt, idx) {
    if (opt && opt.values) return opt.values;
    // fallback: gather unique values from variants
    var seen = [];
    product.variants.forEach(function (v) {
      var val = v['option' + (idx + 1)];
      if (val !== undefined && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  // --- money format ---
  // Shopify format keys use singular _separator (not _separators)
  function formatMoney(cents) {
    var fmt = (window.shopSettings && window.shopSettings.moneyFormat) || '€{{amount}}';
    var n = cents / 100;
    var amount = n.toFixed(2);
    var amountNoDecimals = Math.round(n).toString();
    var amountComma = amount.replace('.', ',');
    var amountNoDecComma = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecComma)
      .replace('{{amount_with_comma_separator}}', amountComma)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amount);
  }

  // --- open / close ---
  function openModal() {
    backdrop.classList.add('is-open');
    modal.classList.add('is-open');
    modal.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    modal.focus();
  }

  function closeModal() {
    backdrop.classList.remove('is-open');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('#qv-close') || e.target === backdrop) closeModal();
  });

  // --- find variant matching current selectedOptions ---
  function findVariant() {
    if (!product) return null;
    return product.variants.find(function (v) {
      return product.options.every(function (opt, i) {
        return v['option' + (i + 1)] === selectedOptions[optName(opt)];
      });
    });
  }

  // --- update price / atc state for current variant ---
  function updateVariantState() {
    var variant = findVariant();
    if (!variant) {
      priceEl.textContent = '';
      compareEl.style.display = 'none';
      badgeEl.style.display = 'none';
      unavailableEl.style.display = 'block';
      atcBtn.disabled = true;
      return;
    }
    unavailableEl.style.display = 'none';
    priceEl.textContent = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareEl.textContent = formatMoney(variant.compare_at_price);
      compareEl.style.display = '';
      var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
      badgeEl.textContent = '-' + pct + '%';
      badgeEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
      badgeEl.style.display = 'none';
    }
    atcBtn.disabled = !variant.available;
    atcBtn.dataset.variantId = variant.id;

    // refresh swatch availability
    product.options.forEach(function (opt) {
      var name = optName(opt);
      var btns = variantsEl.querySelectorAll('[data-option="' + name + '"]');
      btns.forEach(function (btn) {
        var testOpts = Object.assign({}, selectedOptions);
        testOpts[name] = btn.dataset.value;
        var testVariant = product.variants.find(function (v) {
          return product.options.every(function (o, i) {
            return v['option' + (i + 1)] === testOpts[optName(o)];
          });
        });
        btn.classList.toggle('unavailable', !testVariant || !testVariant.available);
      });
    });
  }

  // --- render variant pickers ---
  function renderVariants() {
    var isDefault = product.options.length === 1 && optName(product.options[0]) === 'Title';
    if (isDefault) {
      variantsEl.style.display = 'none';
      return;
    }
    variantsEl.innerHTML = '';
    variantsEl.style.display = '';

    product.options.forEach(function (opt, idx) {
      var name = optName(opt);
      var values = optValues(opt, idx);

      var wrap = document.createElement('div');

      var labelEl = document.createElement('span');
      labelEl.className = 'qv-option-label';
      labelEl.textContent = name;
      wrap.appendChild(labelEl);

      var btnWrap = document.createElement('div');
      btnWrap.style.cssText = 'display:flex;flex-wrap:wrap;gap:0.4rem;';

      values.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'qv-swatch-btn';
        btn.dataset.option = name;
        btn.dataset.value = val;
        btn.textContent = val;
        if (selectedOptions[name] === val) btn.classList.add('active');
        btn.addEventListener('click', function () {
          selectedOptions[name] = val;
          btnWrap.querySelectorAll('[data-option="' + name + '"]').forEach(function (b) {
            b.classList.toggle('active', b.dataset.value === val);
          });
          updateVariantState();
        });
        btnWrap.appendChild(btn);
      });

      wrap.appendChild(btnWrap);
      variantsEl.appendChild(wrap);
    });
  }

  // --- render thumbnails ---
  function renderThumbs(images) {
    thumbsEl.innerHTML = '';
    if (!images || images.length <= 1) return;
    images.slice(0, 6).forEach(function (src, i) {
      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'qv-thumb' + (i === 0 ? ' active' : '');
      thumb.setAttribute('aria-label', 'Image ' + (i + 1));
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.width = 52;
      img.height = 52;
      img.loading = 'lazy';
      thumb.appendChild(img);
      thumb.addEventListener('click', function () {
        imgEl.style.opacity = '0';
        setTimeout(function () {
          imgEl.src = src;
          imgEl.style.opacity = '1';
        }, 150);
        thumbsEl.querySelectorAll('.qv-thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
      thumbsEl.appendChild(thumb);
    });
  }

  // --- populate modal with product data ---
  function populate(data) {
    product = data;

    typeEl.textContent = data.type || '';
    titleEl.textContent = data.title;
    pdpLink.href = (((window.routes && window.routes.root) || '/').replace(/\/$/, '')) + '/products/' + data.handle;

    // default selected options = first *available* variant's values
    // (falls back to the first variant only when everything is sold out),
    // so the size picker lands on an in-stock option and Add to Cart stays active.
    var first = data.variants.find(function (v) { return v.available; }) || data.variants[0];
    selectedOptions = {};
    data.options.forEach(function (opt, i) {
      selectedOptions[optName(opt)] = first['option' + (i + 1)];
    });

    var firstImg = (data.images && data.images[0]) ? data.images[0] : '';
    imgEl.src = firstImg;
    imgEl.alt = data.title;
    renderThumbs(data.images || []);

    renderVariants();
    updateVariantState();

    loading.style.display = 'none';
    content.style.display = '';
  }

  // --- add to cart ---
  // Delegates to window.addToCart (global.js) so the cart drawer refreshes and opens correctly.
  atcBtn.addEventListener('click', function () {
    var variantId = atcBtn.dataset.variantId;
    if (!variantId || typeof window.addToCart !== 'function') return;

    atcBtn.classList.add('loading');
    atcBtn.disabled = true;

    window.addToCart(variantId)
      .then(function () {
        atcBtn.classList.remove('loading');
        atcBtn.classList.add('success');
        atcBtn.querySelector('.qv-atc-label').textContent = (window.theme_strings && window.theme_strings.added) || '✓ Added!';
        setTimeout(function () {
          closeModal();
          setTimeout(function () {
            atcBtn.classList.remove('success');
            atcBtn.querySelector('.qv-atc-label').textContent = atcBtn.dataset.defaultLabel || (window.theme_strings && window.theme_strings.add_to_cart) || 'Add to Cart';
            atcBtn.disabled = false;
          }, 400);
        }, 900);
      })
      .catch(function () {
        atcBtn.classList.remove('loading');
        atcBtn.disabled = false;
      });
  });

  // --- trigger from product cards ---
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-qv-handle]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();

    var handle = trigger.dataset.qvHandle;
    if (!handle) return;

    loading.style.display = '';
    content.style.display = 'none';
    atcBtn.classList.remove('success', 'loading');
    atcBtn.querySelector('.qv-atc-label').textContent = atcBtn.dataset.defaultLabel || (window.theme_strings && window.theme_strings.add_to_cart) || 'Add to Cart';
    atcBtn.disabled = true;
    product = null;

    openModal();

    // Try the locale-prefixed endpoint first; it 404s on some locales, so
    // fall back to the primary-locale endpoint rather than failing.
    var qvRoot = ((window.routes && window.routes.root) || '/').replace(/\/$/, '');
    fetch(qvRoot + '/products/' + handle + '.js')
      .then(function (r) {
        if (r.ok) return r.json();
        return fetch('/products/' + handle + '.js').then(function (r2) { return r2.json(); });
      })
      .then(populate)
      .catch(function () {
        loading.innerHTML = '<p style="color:rgba(13,1,1,0.5);text-align:center;padding:2rem;">Could not load product.</p>';
      });
  });

  atcBtn.dataset.defaultLabel = atcBtn.querySelector('.qv-atc-label').textContent;
})();
